<template>
  <div class="content py-5">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title>
        Reservas
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-dialog
                  ref="dialog_begin"
                  v-model="modal_begin"
                  :return-value.sync="begin_date"
                  persistent
                  lazy
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="begin_date"
                      label="Data inicio"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>

                  <v-date-picker
                    v-model="begin_date"
                    scrollable
                    :header-color="header_color"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text @click="modal_begin = false">
                      Cancelar
                    </v-btn>

                    <v-btn
                      color="success"
                      @click="$refs.dialog_begin.save(begin_date)"
                    >
                      Selecionar
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-dialog
                  ref="dialog_end"
                  v-model="modal_end"
                  :return-value.sync="end_date"
                  persistent
                  lazy
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="end_date"
                      label="Data fim"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>

                  <v-date-picker
                    v-model="end_date"
                    scrollable
                    :header-color="header_color"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text @click="modal_end = false">
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="success"
                      @click="$refs.dialog_end.save(end_date)"
                    >
                      Selecionar
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-btn block color="primary" class="mt-4" @click="filtrar()">
                  Pesquisar
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>

          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm3>
              <v-col align="center">
                <download-excel
                  :data="servicesGrid"
                  :fields="json_fields"
                  name="reservas.xls"
                >
                  <v-btn block class="mt-4 white--text" color="success">
                    Exportar
                    <v-icon right>mdi-file-excel</v-icon>
                  </v-btn>
                </download-excel>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="servicesGrid"
          :search="search"
          class="elevation-1"
          no-data-text="Sem reservas"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <ActionButton
                  message="Detalhes da reserva"
                  icon="assignment"
                  color="info"
                  @onclick="detail(item)"
                />
              </td>
              <td>{{ item.id }}</td>
              <td>{{ item.data_checkin }}</td>
              <td>{{ item.data_checkout }}</td>
              <td>{{ item.nome }}</td>
              <td>{{ item.vehicle }}</td>
              <td>{{ formatHour(item.duracao) }}</td>
              <td>{{ formatValue(item.valor_da_reserva) }}</td>
              <td>{{ formatValue(item.valor_da_multa) }}</td>
              <td>{{ formatValue(item.valor_total) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import Roles from '../../models/Roles';
import ActionButton from '../shared/ActionButtonsTemplate';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import Constants from '../../models/constants/ConstantsRoutes.js';
import ServiceController from '../../controllers/ServiceController.js';
import ConfigurationController from '../../controllers/ConfigurationController';
import VehicleRequestController from '../../controllers/VehicleRequestController';

export default {
  components: { ActionButton },

  data() {
    return {
      profile: localStorage.getItem('profile'),
      header_color: null,
      begin_date: moment()
        .subtract(5, 'days')
        .format('YYYY-MM-DD'),
      end_date: new Date().toISOString().substr(0, 10),
      modal_begin: false,
      modal_end: false,
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      servicesGrid: [],
      service: null,
      search: '',
      json_fields: {
        Id: 'id',
        'Data de checkin': 'data_checkin',
        'Data de checkout': 'data_checkout',
        Solicitante: 'nome',
        Veículo: 'vehicle',
        Duração: {
          field: 'duracao',
          callback: value => {
            return this.formatHour(value);
          },
        },
        'Valor da reserva': {
          field: 'valor_da_reserva',
          callback: value => {
            return this.formatValue(value);
          },
        },
        'Valor da multa': {
          field: 'valor_da_multa',
          callback: value => {
            return this.formatValue(value);
          },
        },
        'Valor total': {
          field: 'valor_total',
          callback: value => {
            return this.formatValue(value);
          },
        },
      },
      headers: [
        { text: 'Ações', value: 'action', sortable: false },
        { text: 'ID', value: 'id' },
        { text: 'Data de Check-in', value: 'data_checkin' },
        { text: 'Data Check-out', value: 'data_checkout' },
        { text: 'Solicitante', value: 'nome' },
        { text: 'Veículo', value: 'vehicle' },
        { text: 'Duração', value: 'duracao' },
        { text: 'Valor da reserva', value: 'valor_da_reserva' },
        { text: 'Valor da multa', value: 'valor_da_multa' },
        { text: 'Valor total', value: 'valor_total' },
      ],
      groupSortDescending: false,
      configurations: {},
      configurationController: new ConfigurationController(this.$resource),
      vehicleRequestController: new VehicleRequestController(this.$resource),
    };
  },

  created() {
    this.catchColor();
    this.serviceController = new ServiceController(this.$resource);
    this.loadData(this.begin_date, this.end_date);
  },

  methods: {
    filtrar() {
      this.loadData(this.begin_date, this.end_date);
    },

    async catchColor() {
      await this.getConfigurations();
      this.header_color = this.configurations.secondary_color
        ? this.configurations.secondary_color.value
        : 'blue';
    },

    async getConfigurations() {
      let configs = await this.configurationController.getAll();
      this.configurations = configs;
    },

    formatHour(valor) {
      let horas = '00';
      let minutos = '00';
      if (valor.hours)
        if (valor.hours < 10) horas = '0' + valor.hours;
        else horas = valor.hours;
      if (valor.minutes)
        if (valor.minutes < 10) minutos = '0' + valor.minutes;
        else minutos = valor.minutes;
      return horas + ':' + minutos;
    },

    formatValue(value) {
      let valorFloat = parseFloat(value);
      return 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
    },

    detail(item) {
      this.$router.push({
        name: Constants.ROUTER_NAME_ADM_VEHICLE_REQUEST_DETAIL,
        params: {
          id: item.id,
        },
      });
      localStorage.setItem('pageBack', Constants.ROUTER_NAME_SERVICE);
    },

    async loadData(begin_date = null, end_date = null) {
      this.blockScreen = true;
      try {
        let response = await this.vehicleRequestController.getReservationReport(
          begin_date,
          end_date,
          'condominio',
          localStorage.getItem('client_id')
        );

        if (response.ok) {
          this.servicesGrid = response.data;
        }
      } catch (error) {
        console.log(error);
        this.$awn.alert('Falha ao obter reservas');
      } finally {
        this.blockScreen = false;
      }
    },

    collapseAll() {
      this.$refs.expandableTable.collapseAll();
    },

    expandAll() {
      this.$refs.expandableTable.expandAll();
    },
  },
};
</script>
